module.exports = __webpack_public_path__ + "static/41gde-34a5d4963e27f1776e48df992abf64ed.gif";